import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TemplateEditor = () => {
  const [templates, setTemplates] = useState([]);
  const [mode, setMode] = useState('edit'); // 'edit' or 'create'
  
  // State for the form fields
  const [selectedKey, setSelectedKey] = useState('');
  const [newKey, setNewKey] = useState(''); // For creating a new template
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  // Fetch templates when the component loads
  const fetchTemplates = async () => {
    try {
      const response = await axios.get('https://loyaltyprogram.navalsupermart.com/api/get_templates.php');
      setTemplates(response.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  // Handle dropdown change to load a template for editing
  const handleSelectChange = (e) => {
    const key = e.target.value;
    setSelectedKey(key);

    if (key) {
      const template = templates.find(t => t.template_key === key);
      if (template) {
        setTitle(template.notification_title);
        setBody(template.notification_body);
      }
    } else {
      setTitle('');
      setBody('');
    }
  };
  
  // Switch to 'create' mode and clear fields
  const handleAddNew = () => {
      setMode('create');
      setSelectedKey('');
      setNewKey('');
      setTitle('');
      setBody('');
  };

  // Switch back to 'edit' mode
  const handleSelectExisting = () => {
      setMode('edit');
      setNewKey('');
  };

  // Handle form submission for both creating and updating
  const handleSubmit = async (e) => {
    e.preventDefault();

    let url = '';
    let payload = {};

    if (mode === 'create') {
        if (!newKey) {
            alert('Template Name (Key) is required.');
            return;
        }
        url = 'https://loyaltyprogram.navalsupermart.com/api/create_template.php';
        payload = { template_key: newKey, notification_title: title, notification_body: body };
    } else { // 'edit' mode
        if (!selectedKey) {
            alert('Please select a template to edit.');
            return;
        }
        url = 'https://loyaltyprogram.navalsupermart.com/api/update_template.php';
        payload = { template_key: selectedKey, notification_title: title, notification_body: body };
    }

    console.log('Submitting data:', payload);

    try {
      const response = await axios.post(url, payload);
      if (response.data.success) {
        alert(`Template ${mode === 'create' ? 'created' : 'updated'} successfully!`);
        fetchTemplates(); // Refresh the list
        handleSelectExisting(); // Switch back to edit mode
      } else {
        alert(`Error: ${response.data.message}`);
      }
    } catch (error) {
      alert(`Error submitting template.`);
      console.error(error);
    }
  };

  return (
    <div>
      <h2>Notification Template Editor</h2>
      
      <button onClick={handleAddNew} style={{ marginRight: '10px' }}>Add New Template</button>
      <button onClick={handleSelectExisting}>Edit Existing Template</button>
      
      <hr style={{ margin: '20px 0' }} />

      <form onSubmit={handleSubmit}>
        {mode === 'edit' ? (
            <div>
                <label>Select Template to Edit:</label><br />
                <select onChange={handleSelectChange} value={selectedKey}>
                  <option value="">-- Select Template --</option>
                  {templates.map(t => (
                    <option key={t.template_key} value={t.template_key}>
                      {t.template_key}
                    </option>
                  ))}
                </select><br /><br />
            </div>
        ) : (
            <div>
                <label>New Template Name (Key):</label><br />
                <input 
                    type="text" 
                    value={newKey} 
                    onChange={e => setNewKey(e.target.value.replace(/ /g, '_'))} 
                    placeholder="e.g., reward_redeemed"
                    required 
                /><br /><br />
            </div>
        )}

        {(selectedKey || mode === 'create') && (
          <>
            <label>Notification Title:</label><br />
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              style={{ width: '500px' }}
            /><br />

            <label>Notification Body (Use placeholders like [customerName], [points]):</label><br />
            <textarea
              value={body}
              onChange={(e) => setBody(e.target.value)}
              required
              style={{ width: '500px', height: '150px' }}
            /><br />

            <button type="submit">{mode === 'create' ? 'Create Template' : 'Update Template'}</button>
          </>
        )}
      </form>
    </div>
  );
};

export default TemplateEditor;